module.exports = __webpack_public_path__ + "static/media/PSD.9ec84615.svg";